import React from 'react';
import { Box, Typography, ToggleButtonGroup, ToggleButton, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { toggleContainerSx, toggleBoxSx, toggleLabelSx } from '../../../styles';

/**
 * FilterToggle - A toggle button group for switching between views
 *
 * @param {string} value - Currently selected value
 * @param {function} onChange - Callback when selection changes (event, newValue)
 * @param {Array} options - Array of { value, label, icon, tooltip } objects
 * @param {string} toggleLabel - Optional label for the toggle group (e.g., "Toggle View")
 * @param {number} width - Width of the toggle container (default 125)
 */
function FilterToggle({ value, onChange, options, toggleLabel = 'Toggle View', width = 125 }) {
  const theme = useTheme();

  return (
    <Box sx={toggleContainerSx(theme, width + (options.length - 2) * 70)}>
      <Box sx={toggleBoxSx(theme, width + (options.length - 2) * 70)}>
        {toggleLabel && (
          <Box sx={{ maxWidth: '60px', textAlign: 'center', paddingBottom: '0px' }}>
            <Typography
              variant="body2"
              sx={{
                paddingRight: '2px',
                paddingLeft: '6px',
                color: theme.palette.text.secondary,
                fontSize: '9px',
              }}
            >
              {toggleLabel}
            </Typography>
          </Box>
        )}
        <ToggleButtonGroup
          sx={{
            color: theme.palette.text.secondary,
            backgroundColor: theme.tableHeader.highlight,
            height: '100%',
            paddingLeft: '0px',
            '& .MuiToggleButton-root': {
              borderColor:
                theme.palette.mode === 'light'
                  ? theme.palette.grey[400]
                  : theme.palette.grey[700],
              borderRadius: '0px',
              '&:not(:last-child)': {
                borderRight: `1px solid ${theme.palette.divider}`,
              },
            },
          }}
          value={value}
          exclusive
          onChange={onChange}
          size="small"
          aria-label="View Toggle"
        >
          {options.map((option) => (
            <ToggleButton
              key={option.value}
              style={{ textTransform: 'none' }}
              value={option.value}
              sx={{ paddingBottom: '12px', minWidth: '70px' }}
            >
              <Tooltip title={option.tooltip || option.label}>
                <Box sx={{ paddingTop: '8px' }}>
                  {option.icon}
                  <Typography
                    variant="body2"
                    align="center"
                    sx={{ mt: -1, fontWeight: 'bold', fontSize: '8px' }}
                  >
                    {option.label}
                  </Typography>
                </Box>
              </Tooltip>
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Box>
    </Box>
  );
}

export default FilterToggle;
